module.exports = __webpack_public_path__ + "img/Daryl.24a31b5e.jpg";